export const games = [
  {
    id: 'classic-mahjong',
    name: '经典麻将',
    category: 'classic',
    description: '正宗中国经典麻将玩法，包含万、条、筒三种花色，支持吃、碰、杠、胡等传统规则，还原最原汁原味的麻将体验。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20mahjong%20tiles%20arranged%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20rich%20green%20felt%20surface%2C%20artistic%20product%20photography%20with%20warm%20amber%20accents%2C%20clean%20minimal%20background&width=800&height=600&seq=mahjong-classic-01&orientation=landscape',
    players: '2-4人',
    difficulty: '中等',
    playCount: '158万+',
    rating: 4.8,
    featured: true,
  },
  {
    id: 'sichuan-mahjong',
    name: '四川麻将',
    category: 'regional',
    description: '风靡四川地区的血战到底玩法，缺一门、刮风下雨特色规则，血战模式让每局比赛更加刺激紧张，深受川渝玩家喜爱。',
    image: 'https://readdy.ai/api/search-image?query=Sichuan%20style%20mahjong%20game%20display%20with%20vibrant%20red%20and%20gold%20tiles%20on%20dark%20green%20felt%2C%20warm%20dramatic%20lighting%2C%20Chinese%20new%20year%20decorative%20elements%2C%20rich%20texture%2C%20professional%20product%20photography%20with%20clean%20composition&width=800&height=600&seq=mahjong-sichuan-02&orientation=landscape',
    players: '4人',
    difficulty: '进阶',
    playCount: '126万+',
    rating: 4.9,
    featured: true,
  },
  {
    id: 'guangdong-mahjong',
    name: '广东麻将',
    category: 'regional',
    description: '流行于广东地区的推倒胡玩法，鸡平胡、清一色等多种牌型组合，节奏明快、规则灵活，适合追求速度与激情的玩家。',
    image: 'https://readdy.ai/api/search-image?query=Cantonese%20style%20mahjong%20layout%20with%20colorful%20tiles%20and%20delicate%20tea%20set%20on%20wooden%20table%2C%20warm%20ambient%20light%2C%20traditional%20Chinese%20aesthetic%2C%20soft%20shadows%2C%20elegant%20minimalist%20product%20shot%20with%20subtle%20gold%20highlights&width=800&height=600&seq=mahjong-guangdong-03&orientation=landscape',
    players: '4人',
    difficulty: '简单',
    playCount: '98万+',
    rating: 4.7,
    featured: false,
  },
  {
    id: 'shanghai-mahjong',
    name: '上海麻将',
    category: 'regional',
    description: '上海本地特色的清混碰玩法，讲究牌型组合与计番，规则细腻优雅，适合喜欢策略思考的麻将爱好者。',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%20style%20mahjong%20tiles%20elegantly%20arranged%20with%20art%20deco%20accents%2C%20warm%20vintage%20lighting%2C%20sophisticated%20Chinese%20modern%20aesthetic%2C%20rich%20dark%20green%20felt%2C%20professional%20photography%20with%20soft%20depth%20of%20field&width=800&height=600&seq=mahjong-shanghai-04&orientation=landscape',
    players: '4人',
    difficulty: '中等',
    playCount: '72万+',
    rating: 4.6,
    featured: false,
  },
  {
    id: 'taiwan-mahjong',
    name: '台湾麻将',
    category: 'regional',
    description: '十六张牌的台湾麻将玩法，牌型丰富多变，增加了额外的策略深度，适合追求复杂牌型的进阶玩家。',
    image: 'https://readdy.ai/api/search-image?query=Taiwanese%20mahjong%20with%2016%20tiles%20layout%20on%20bamboo%20mat%2C%20warm%20tropical%20lighting%2C%20traditional%20Chinese%20decor%2C%20rich%20earthy%20tones%2C%20elegant%20minimalist%20product%20photography%20with%20soft%20natural%20shadows&width=800&height=600&seq=mahjong-taiwan-05&orientation=landscape',
    players: '4人',
    difficulty: '困难',
    playCount: '45万+',
    rating: 4.5,
    featured: false,
  },
  {
    id: 'hongkong-mahjong',
    name: '香港麻将',
    category: 'regional',
    description: '港式麻将十三张玩法，番数计算独特，花牌运用灵活，节奏紧凑刺激，是香港影视作品中常见的经典玩法。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20style%20mahjong%20scene%20with%20neon%20inspired%20warm%20mood%20lighting%2C%20colorful%20tiles%20on%20dark%20felt%2C%20modern%20Chinese%20urban%20aesthetic%2C%20vibrant%20yet%20refined%20product%20photography%20with%20clean%20composition&width=800&height=600&seq=mahjong-hongkong-06&orientation=landscape',
    players: '4人',
    difficulty: '中等',
    playCount: '83万+',
    rating: 4.7,
    featured: true,
  },
  {
    id: 'riichi-mahjong',
    name: '日本麻将',
    category: 'international',
    description: '日本立直麻将玩法，包含立直、一发、宝牌等独特规则，策略性强，是国际麻将比赛常用的竞技规则。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20riichi%20mahjong%20tiles%20beautifully%20arranged%20with%20minimalist%20Japanese%20aesthetic%2C%20warm%20wooden%20surface%2C%20soft%20zen%20lighting%2C%20clean%20composition%2C%20elegant%20product%20photography%20with%20natural%20textures&width=800&height=600&seq=mahjong-riichi-07&orientation=landscape',
    players: '4人',
    difficulty: '困难',
    playCount: '36万+',
    rating: 4.4,
    featured: false,
  },
  {
    id: 'single-mahjong',
    name: '单机麻将',
    category: 'single',
    description: '无需联网的单机麻将模式，AI对手智能对战，随时随地想玩就玩，适合通勤路上、休息时间独自享受麻将乐趣。',
    image: 'https://readdy.ai/api/search-image?query=Solo%20mahjong%20game%20on%20a%20modern%20tablet%20screen%20with%20warm%20cozy%20home%20setting%2C%20soft%20candlelight%20mood%2C%20comfortable%20ambiance%2C%20digital%20display%20photography%20with%20rich%20warm%20tones%20and%20clean%20framing&width=800&height=600&seq=mahjong-single-08&orientation=landscape',
    players: '1人',
    difficulty: '简单',
    playCount: '210万+',
    rating: 4.9,
    featured: true,
  },
];

export const featuredGames = games.filter(g => g.featured);